export const environment = {
  production: false,
  contentful: {
    spaceId: 'ertyhukhlvrl',
    accessToken: '-8jByx7qnH9lWSMTeyew26HGK7YE7s7pQu8t8cdTxHk',
    environment: 'master', // replace with your environment ID if needed - master is the default production environment in Contentful
  }
  
  // // 
  // contentful: {
  //   spaceId: '5qty3xixiykb',
  //   accessToken: 'qcz0RNlrJArezheTARSdOKgN7qzfhU16Y-3c3Mpey14',
  //   environment: 'master', // replace with your environment ID if needed - master is the default production environment in Contentful
  // }
};